module.exports = __webpack_public_path__ + "assets/1ad77f14bf4f46da54771f6f18391311.svg";